import { render } from "./navbar.vue?vue&type=template&id=6dd56b3b&ts=true"
import script from "./navbar.component.ts?vue&type=script&lang=ts"
export * from "./navbar.component.ts?vue&type=script&lang=ts"

import exportComponent from "D:\\trainsit project\\LTMS\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__